import React, { Component } from "react";
import { Modal } from "antd";
import axios from "axios";
import { resolveImageUrl } from "../utils/Storage";

const cacheImagens = {};
const requisicoesImagens = {};

const normalizarProdutoId = value => {
  if (value == null || value === '') return '';

  if (typeof value === 'object') {
    return normalizarProdutoId(
      value.prod_idf ||
      value.pest_item ||
      value.idf ||
      value.nfi_produto ||
      value.mi_item ||
      value.key
    );
  }

  const texto = String(value);
  if (texto.indexOf('_') >= 0) {
    return texto.split('_')[0];
  }
  return texto;
};

const montarUrlImagem = (empresa, imagem) => {
  if (!imagem) return '';

  const valor = String(imagem).trim();
  if (!valor) return '';

  if (/^(https?:|data:|blob:)/i.test(valor)) return valor;
  if (/^emp[^/]+\/produtos\//i.test(valor)) return resolveImageUrl(valor);

  if (!empresa) return '';
  return resolveImageUrl(`emp${empresa}/produtos/${valor}`);
};

export default class ItemFotoProduto extends Component {
  state = {
    src: '',
    previewVisible: false,
    erro: false,
  };

  componentDidMount() {
    this.carregarImagem();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.produtoId !== this.props.produtoId ||
      prevProps.prodImagem !== this.props.prodImagem ||
      prevProps.prodEmpresa !== this.props.prodEmpresa
    ) {
      this.carregarImagem();
    }
  }

  getProdutoId = () => normalizarProdutoId(this.props.produtoId);

  notificarVisibilidade = visivel => {
    if (typeof this.props.onVisibilidadeChange === 'function') {
      this.props.onVisibilidadeChange(Boolean(visivel));
    }
  };

  carregarImagem = async () => {
    const produtoId = this.getProdutoId();
    const srcInformado = montarUrlImagem(this.props.prodEmpresa, this.props.prodImagem);

    if (srcInformado) {
      this.setState({ src: srcInformado, erro: false }, () => this.notificarVisibilidade(true));
      return;
    }

    // Enquanto resolve um novo produto, oculta a foto anterior imediatamente.
    this.setState({ src: '', erro: false }, () => this.notificarVisibilidade(false));

    if (!produtoId || produtoId === '0') {
      return;
    }

    if (cacheImagens[produtoId] !== undefined) {
      const srcCache = cacheImagens[produtoId] || '';
      this.setState({ src: srcCache, erro: false }, () => this.notificarVisibilidade(Boolean(srcCache)));
      return;
    }

    try {
      if (!requisicoesImagens[produtoId]) {
        requisicoesImagens[produtoId] = axios
          .get(`/produtos/show/${produtoId}`)
          .then(response => {
            const dados = response && response.data ? (response.data.dados || response.data) : {};
            const src = montarUrlImagem(dados.prod_empresa, dados.prod_imagem);
            cacheImagens[produtoId] = src || '';
            return cacheImagens[produtoId];
          })
          .catch(() => {
            cacheImagens[produtoId] = '';
            return '';
          })
          .then(src => {
            delete requisicoesImagens[produtoId];
            return src;
          });
      }

      const src = await requisicoesImagens[produtoId];
      if (this.getProdutoId() === produtoId) {
        this.setState({ src: src || '', erro: false }, () => this.notificarVisibilidade(Boolean(src)));
      }
    } catch (e) {
      if (this.getProdutoId() === produtoId) {
        this.setState({ src: '', erro: true }, () => this.notificarVisibilidade(false));
      }
    }
  };

  onErroImagem = () => {
    const produtoId = this.getProdutoId();
    if (produtoId) cacheImagens[produtoId] = '';
    this.setState({ src: '', erro: true, previewVisible: false }, () => this.notificarVisibilidade(false));
  };

  render() {
    const tamanho = Number(this.props.tamanho || 48);
    const { src, previewVisible } = this.state;

    // Produto sem imagem: não renderiza placeholder nem reserva espaço.
    if (!src) return null;

    const conteudo = (
      <React.Fragment>
        <div
          title="Clique para ampliar"
          onClick={() => this.setState({ previewVisible: true })}
          style={{
            width: tamanho,
            height: tamanho,
            minWidth: tamanho,
            border: '1px solid #e8e8e8',
            borderRadius: 6,
            background: '#fff',
            padding: 2,
            cursor: 'zoom-in',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          <img
            src={src}
            alt={this.props.alt || 'Foto do produto'}
            onError={this.onErroImagem}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </div>

        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={() => this.setState({ previewVisible: false })}
          width="70%"
          centered
          destroyOnClose
        >
          <div style={{ textAlign: 'center', paddingTop: 20 }}>
            <img
              src={src}
              alt={this.props.alt || 'Foto do produto'}
              onError={this.onErroImagem}
              style={{ maxWidth: '100%', maxHeight: '75vh', objectFit: 'contain' }}
            />
          </div>
        </Modal>
      </React.Fragment>
    );

    if (this.props.containerStyle) {
      return (
        <div style={this.props.containerStyle}>
          {conteudo}
        </div>
      );
    }

    return conteudo;
  }
}




// WEBPACK FOOTER //
// ./src/components/ItemFotoProduto.js